import type { ConsentMedicalRecordsFormValues } from './MedicalRecordsConsent.types';

type FieldConfig = {
  label: string;
  helperText?: string;
};

export const FIELD_CONFIG: Record<string, FieldConfig> = {
  practitionerType: {
    label: 'Type of health practitioner',
    helperText: 'For example: GP, specialist, or physiotherapist',
  },
  practitionerFullName: {
    label: "Practitioner's full name",
    helperText: 'Please include first name and surname. For example: Dr John Smith',
  },
  practitionerClinicName: {
    label: 'Clinic name',
  },
  practitionerClinicAddress: {
    label: 'Clinic address',
    helperText: 'Street, suburb, state, postcode',
  },
  practitionerClinicPhone: {
    label: 'Clinic phone number',
  },
  practitionerClinicEmail: {
    label: 'Clinic email address (optional)',
  },
  previousClinicHasPreviousClinic: {
    label: "I'm moving from another medicinal cannabis clinic to Alternaleaf",
  },
  previousClinicName: {
    label: 'Clinic name',
  },
  previousClinicEmail: {
    label: 'Clinic email address',
  },
  representativeIsRepresentative: {
    label: "I'm a legally appointed patient representative signing on behalf of the patient",
  },
  representativeFullName: {
    label: 'Your name',
  },
  representativeRelationship: {
    label: 'Relationship to patient',
    helperText: 'For example: parent or guardian',
  },
  signature: {
    label: 'Signature',
  },
};

export const DEFAULT_FORM_VALUES: ConsentMedicalRecordsFormValues = {
  practitionerType: '',
  practitionerFullName: '',
  practitionerClinicName: '',
  practitionerClinicAddress: '',
  practitionerClinicPhone: '',
  previousClinic: {
    hasPreviousClinic: false,
    name: '',
    email: '',
  },
  representative: {
    isRepresentative: false,
  },
  signature: '',
  signatureDate: new Date(),
};
